import { create } from "zustand";

import { TJobListing } from "@type/api/corporation/types";

type TJobListingStore = {
  selectedJobListing?: Partial<TJobListing>;
  onSetSelectedJobListing: (selectedJobListing?: Partial<TJobListing>) => void;
};

export const useJobListingStore = create<TJobListingStore>((set) => ({
  selectedJobListing: undefined,
  onSetSelectedJobListing: (selectedJobListing) => {
    set({ selectedJobListing });
  },
}));
